import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-5 z-40 w-11 h-11 flex items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}